import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Projects.css";
import ImgGrid from "./ImgGrid";
// import ApprovalScope from "./ApprovalScope";
import Gallery from "./Gallery";
// import BeforeAfter from "./BeforeAfter";
import Footer from "../components/Footer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

/* ===== IMAGE IMPORTS (src folder) ===== */

import featuredGallery01 from "../image/featured-project-gallery/project-gallery-01.png";
import featuredGallery02 from "../image/featured-project-gallery/project-gallery-02.jpeg";
import featuredGallery03 from "../image/featured-project-gallery/project-gallery-03.jpeg";
import featuredGallery04 from "../image/featured-project-gallery/project-gallery-04.png";
import featuredGallery05 from "../image/featured-project-gallery/project-gallery-05.jpg";
// import featuredGallery05 from "../image/interior-image-ai/image6.png";
// import featuredGallery06 from "../image/interior-image-ai/image2.png";
import featuredGallery06 from "../image/featured-project-gallery/project-gallery-06.jpg";
import featuredGallery07 from "../image/featured-project-gallery/project-gallery-07.jpg";
// import featuredGallery07 from "../image/interior-image-ai/image1.png";
// import featuredGallery08 from "../image/interior-image-ai/image4.png";
import featuredGallery08 from "../image/featured-project-gallery/project-gallery-08.jpg";
import featuredGallery09 from "../image/featured-project-gallery/project-gallery-09.jpg";
// import featuredGallery09 from "../image/interior-image-ai/imgage5.png";
// import featuredGallery10 from "../image/interior-image-ai/image3.png";
import featuredGallery10 from "../image/featured-project-gallery/project-gallery-10.jpg";
import featuredGallery11 from "../image/featured-project-gallery/project-gallery-11.png";
import featuredGallery12 from "../image/featured-project-gallery/project-gallery-12.png";
import featuredGallery13 from "../image/featured-project-gallery/project-gallery-13.jpeg";
import featuredGallery14 from "../image/featured-project-gallery/project-gallery-14.jpeg";
import featuredGallery15 from "../image/featured-project-gallery/project-gallery-15.png";
import featuredGallery16 from "../image/featured-project-gallery/project-gallery-16.png";
import featuredGallery17 from "../image/featured-project-gallery/project-gallery-17.png";
import featuredGallery18 from "../image/featured-project-gallery/project-gallery-18.png";

import vedEstate01 from "../image/architecture-projects/ved-estate-01.png";
import vedEstate02 from "../image/architecture-projects/ved-estate-02.png";
import nagpurCommercialElevation from "../image/architecture-projects/nagpur-commercial-elevation.jpg";

import pastelBedroom from "../image/interior-projects/pastel-bedroom.png";
import pastelUtilityKitchen from "../image/interior-projects/pastel-utility-kitchen.png";
import pastelMainKitchen from "../image/interior-projects/pastel-main-kitchen.png";
import pastelLivingDining01 from "../image/interior-projects/pastel-living-dining-01.png";
import pastelLivingDining02 from "../image/interior-projects/pastel-living-dining-02.png";
import pastelBedroomStudy from "../image/interior-projects/pastel-bedroom-study.png";
import pastelBedroomWardrobe from "../image/interior-projects/pastel-bedroom-wardrobe.png";
import pastelLivingDining03 from "../image/interior-projects/pastel-living-dining-03.png";
import orchidTvUnit01 from "../image/interior-projects/orchid-tv-unit-01.jpeg";
import orchidTvUnit02 from "../image/interior-projects/orchid-tv-unit-02.jpeg";
import orchidFoyer01 from "../image/interior-projects/orchid-foyer-01.jpeg";
import orchidLiving01 from "../image/interior-projects/orchid-living-01.jpeg";
import orchidTvUnit03 from "../image/interior-projects/orchid-tv-unit-03.jpeg";
import orchidStorageDetail from "../image/interior-projects/orchid-storage-detail.jpeg";
import orchidLiving02 from "../image/interior-projects/orchid-living-02.jpeg";
import orchidKitchen01 from "../image/interior-projects/orchid-kitchen-01.jpeg";
import orchidKitchen02 from "../image/interior-projects/orchid-kitchen-02.jpeg";
import orchidFoyer02 from "../image/interior-projects/orchid-foyer-02.jpeg";
import orchidLiving03 from "../image/interior-projects/orchid-living-03.jpeg";
import warmBedroom01 from "../image/interior-projects/warm-bedroom-01.jpeg";
import warmBedroom02 from "../image/interior-projects/warm-bedroom-02.jpeg";
import warmLiving01 from "../image/interior-projects/warm-living-01.jpeg";
import warmLivingTvUnit from "../image/interior-projects/warm-living-tv-unit.jpeg";
import warmBedroom03 from "../image/interior-projects/warm-bedroom-03.jpeg";
import warmKitchen01 from "../image/interior-projects/warm-kitchen-01.jpeg";
import warmBedroom04 from "../image/interior-projects/warm-bedroom-04.jpeg";
import warmBedroom05 from "../image/interior-projects/warm-bedroom-05.jpeg";
import warmDining01 from "../image/interior-projects/warm-dining-01.jpeg";
import warmBedroom06 from "../image/interior-projects/warm-bedroom-06.jpeg";
import kidsStudyBedroom from "../image/interior-projects/kids-study-bedroom.jpeg";

// import katrajFloor1 from "../image/projects-grid-images/katraj-project-floorplan/katraj1.png"
// import katrajFloor2 from "../image/projects-grid-images/katraj-project-floorplan/katraj2.png"
// import katrajFloor3 from "../image/projects-grid-images/katraj-project-floorplan/katraj3.png"
// import katrajFloor4 from "../image/projects-grid-images/katraj-project-floorplan/katraj4.png"
// import katrajFloor5 from "../image/projects-grid-images/katraj-project-floorplan/05-parking-floor-plan(1).png"
// import katrajFloor6 from "../image/projects-grid-images/katraj-project-floorplan/katraj-floor-plans-complete.png"

import manjariFloor1 from "../image/projects-grid-images/manjari-project-floorplan/parking-plan (2).png"
import manjariFloor2 from "../image/projects-grid-images/manjari-project-floorplan/ground-floor-plan.png"
import manjariFloor3 from "../image/projects-grid-images/manjari-project-floorplan/1st-floor-plan.png"
import manjariFloor4 from "../image/projects-grid-images/manjari-project-floorplan/tares-floor.png"
import manjariFloor5 from "../image/projects-grid-images/manjari-project-floorplan/3d-plan.png"
// import manjariFloor5 from "../image/projects-grid-images/manjari-project-floorplan/manjari-floor-plans-complete.png"

import HeroProjects from "./HeroProjects";
import { useNavigate } from "react-router-dom";

/* ===== PROJECT DATA ===== */

const fullViewProjects = [
  {
    // id: "airport-theme-mix-lounge",
     id: "Proposed commercial Airport Theme development",
    title: "Proposed commercial Airport Theme development",
    category: "Architecture",
    location: "Pune",
    year: "2024",
    img: featuredGallery01,
    images: [featuredGallery01],
    desc: "A premium lounge space designed with a hospitality-style palette, elegant finishes, and a polished guest experience.",
  },

  {
    id: "nigadi-bungalow-shinde",
    title: "Nigadi Bungalow - Interior",
    category: "Interior",
    location: "Pune",
    year: "2024",
    img: featuredGallery07,
    images: [
      featuredGallery05,
      featuredGallery06,
      featuredGallery07,
      featuredGallery08,
      featuredGallery09,
      featuredGallery10,
    ],
    desc: "Finished bungalow interior views with warm detailing and practical storage.",
  },
  {
    id: "pastel-full-home-interior",
    title: "Pastel Full Home Interior",
    category: "Interior",
    location: "Pune",
    year: "2026",
    img: pastelLivingDining02,
    images: [
      pastelLivingDining02,
      pastelLivingDining01,
      pastelLivingDining03,
      pastelBedroom,
      pastelBedroomStudy,
      pastelBedroomWardrobe,
      pastelMainKitchen,
      pastelUtilityKitchen,
    ],
    desc: "A soft pastel full-home interior featuring coordinated living, dining, bedroom, wardrobe, and kitchen spaces.",
  },
  {
    id: "orchid-tv-kitchen-home",
    title: "Orchid TV Unit & Kitchen Home",
    category: "Interior",
    location: "Pune",
    year: "2026",
    img: orchidLiving01,
    images: [
      orchidLiving01,
      orchidTvUnit01,
      orchidTvUnit02,
      orchidTvUnit03,
      orchidLiving02,
      orchidLiving03,
      orchidStorageDetail,
      orchidKitchen01,
      orchidKitchen02,
      orchidFoyer01,
      orchidFoyer02,
      kidsStudyBedroom,
    ],
    desc: "Executed apartment interiors with a curved TV unit, foyer storage, ceiling lighting, and compact green kitchen.",
  },
  {
    id: "warm-wood-residence",
    title: "Warm Wood Residence",
    category: "Interior",
    location: "Pune",
    year: "2026",
    img: warmLivingTvUnit,
    images: [
      warmBedroom01,
      warmBedroom02,
      warmBedroom06,
      warmBedroom03,
      warmBedroom04,
      warmBedroom05,
      warmLiving01,
      warmLivingTvUnit,
      warmKitchen01,
      warmDining01,
      
    ],
    desc: "Warm wood-led home interiors with bedrooms, living-room feature walls, kitchen, dining, and built-in storage.",
  },
  {
    id: "akhilesh-rai",
    title: "Residential Project",
    category: "Architecture",
    location: "Pune",
    year: "2024",
    img: featuredGallery03,
    images: [featuredGallery02, featuredGallery03],
    desc: "A compact residential project shaped with clean planning, balanced proportions, and a refined architectural presentation.",
  },
  {
    id: "goa-ganesh-sir",
    title: "Goa Villa Residence",
    category: "Architecture",
    location: "Goa",
    year: "2024",
    img: featuredGallery04,
    images: [featuredGallery04],
    desc: "A villa residence with a strong exterior language, sculpted volumes, and a welcoming contemporary façade.",
  },
  // {
  //   id: "latur-kalidas-sendkar",
  //   title: "Proposed Mixed Used Project",
  //   category: "Architecture",
  //   location: "Latur",
  //   year: "2024",
  //   img: featuredGallery12,
  //   images: [
  //     featuredGallery11,
  //     featuredGallery12,
  //     featuredGallery13,
  //     featuredGallery14,
  //   ],
  //   desc: "Residential architectural visuals and reference views from the project folder.",
  // },

{
  id: "latur-kalidas-sendkar",
  title: "Proposed Mixed Used Project",
  category: "Architecture",
  location: "Latur",
  year: "2024",
  img: featuredGallery12,
  images: [
    featuredGallery11,
    featuredGallery12,
    featuredGallery13,
    featuredGallery14,
  ],
  desc: "A thoughtfully planned mixed-use development featuring a ground-floor clinic, a spacious duplex bungalow across the first and second floors, and two well-designed 1BHK residences on the top floor.",
},

  {
    id: "manjari-swapnil-khopade",
    // title: "Manjari Project - residential architecture",
     title: "Proposed Residential bunglow at Manjari Pune",
    category: "Architecture",
    location: "Manjari",
    year: "2024",
    img: featuredGallery16,
    images: [featuredGallery16, featuredGallery15, manjariFloor1, manjariFloor2, manjariFloor3, manjariFloor4, manjariFloor5 ],
    desc: "A residential façade design with carefully composed elevations, balanced massing, and a timeless street presence.",
  },
  {
    id: "studio-apartment-katraj",
    title: "  Katraj Project - Studio Apartment",
    category: "Architecture",
    location: "Katraj",
    year: "2024",
    img: featuredGallery18,
    images: [featuredGallery18, featuredGallery17 ],
    desc: "A compact studio apartment layout focused on efficient planning, smart storage, and clean building massing.",
  },

  {
    id: "ved-estate-commercial",
    title: "VED Estate Commercial Complex",
    category: "Architecture",
    location: "Pune",
    year: "2026",
    img: vedEstate01,
    images: [vedEstate01, vedEstate02],
    desc: "A commercial facade with striking glass frontage, bold red volumes, and a strong street-level presence.",
  },
  {
    id: "nagpur-commercial-elevation",
    title: "Proposed Mixed-use development at Nagpur",
    category: "Architecture",
    location: "Nagpur",
    year: "2026",
    img: nagpurCommercialElevation,
    images: [nagpurCommercialElevation],
    desc: "Mixed-use commercial elevation with yellow facade massing, glass frontage, and a strong roofline identity.",
  },

];

export default function ProjectsPage({openContactModal, openMeetingModal, showCTA}) {
  const [dwProjCModal, setDwProjCModal] = useState(null);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const [activeShowcaseCategory, setActiveShowcaseCategory] = useState("Architecture");
  const navigate = useNavigate();

  const showcaseCategories = ["Architecture", "Interior"];

  const filteredShowcaseProjects =
    fullViewProjects.filter(
      (item) => item.category === activeShowcaseCategory
    );

  const openModal = (project) => {
    setDwProjCModal(project);
    const coverIndex = project.images.indexOf(project.img);
    setCurrentImgIndex(coverIndex !== -1 ? coverIndex : 0);
  };

  React.useEffect(() => {
    if (!dwProjCModal) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setDwProjCModal(null);
      } else if (e.key === "ArrowLeft" && dwProjCModal.images?.length > 1) {
        setCurrentImgIndex((prev) =>
          prev === 0 ? dwProjCModal.images.length - 1 : prev - 1
        );
      } else if (e.key === "ArrowRight" && dwProjCModal.images?.length > 1) {
        setCurrentImgIndex((prev) =>
          prev === dwProjCModal.images.length - 1 ? 0 : prev + 1
        );
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [dwProjCModal]);

  return (
    <div className="dw-projC-page">

      <HeroProjects
        openContactModal={openContactModal}
        openMeetingModal={openMeetingModal}
      />

      <Gallery/>

      <section className="dw-fullview-section">
        <div className="dw-fullview-container">
          <motion.div
            className="dw-fullview-header"
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <div className="dw-fullview-eyebrow">Dwellora Portfolio</div>
            <h2>Selected Spaces</h2>
            <p>
              Real interior details, modular kitchens, living rooms, bedrooms,
              and facade concepts presented in one clean visual grid.
            </p>
          </motion.div>

          <div className="dw-fullview-tabs" aria-label="Project categories">
            {showcaseCategories.map((category) => (
              <button
                type="button"
                key={category}
                className={
                  activeShowcaseCategory === category ? "active" : ""
                }
                onClick={() => setActiveShowcaseCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="dw-fullview-grid">
            {filteredShowcaseProjects.map((item, index) => (
              <motion.article
                className="dw-fullview-card"
                key={item.id}
                initial={{
                  opacity: 0,
                  y: 40,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.2,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
                onClick={() => openModal(item)}
              >
                <img src={item.img} alt={item.title} className="dw-fullview-img" />
                <div className="dw-fullview-overlay">
                  <span className="dw-fullview-kicker">{item.category}</span>
                  <h3>{item.title}</h3>
                  {/* <p>{item.location} - {item.year} - {item.images.length} views</p>
                  <p>{dwProjCModal.desc}</p> */}

<p>{item.location} - {item.year} - {item.images.length} views</p>
<p className="dw-fullview-desc">{item.desc}</p>  

                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <section className="proj-section">
        <div className="proj-container">
          <h2 className="proj-title">Our Completed Projects</h2>
          <p className="proj-subtitle">
            Explore thoughtfully designed homes, interiors, and construction work delivered with practical planning, clean detailing, and premium finish.
          </p>
          <ImgGrid />
        </div>
      </section>

      {/* <BeforeAfter/> */}

      {/* ================= TIMELINE ================= */}
      <section className="dw-projC-timeline">
        <motion.h2
          className="dw-projC-heading"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          HOW IT WORKS
        </motion.h2>

        <motion.p
          className="dw-projC-subheading"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          viewport={{ once: true }}
        >
          From concept to completion, our streamlined design and construction
          process ensures transparency, expert guidance, and timely delivery
          so you experience a smooth and stress-free journey from day one.
        </motion.p>

        <div className="dw-projC-timeline-box">
          {[
            {
              step: "01",
              title: "Raise a Request",
              desc: "Share your space details, requirements, and budget. We carefully understand your vision before moving ahead.",
            },
            {
              step: "02",
              title: "Meet our Expert",
              desc: "Consult with our design and construction specialists for practical, cost-effective solutions tailored to you.",
            },
            {
              step: "03",
              title: "Book with us",
              desc: "Finalize scope, pricing, and timelines with complete transparency and zero hidden costs.",
            },
            {
              step: "04",
              title: "Receive Plans",
              desc: "Get detailed layouts and 3D designs crafted to match your style and functional needs.",
            },
            {
              step: "05",
              title: "Track and Transact",
              desc: "Monitor project progress with milestone updates and structured payment stages.",
            },
            {
              step: "06",
              title: "Settle in",
              desc: "Experience timely handover, premium quality, and a beautifully finished space ready to enjoy.",
            },
          ].map((item, index) => (
            <motion.div
              className="dw-projC-time-card"
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <span>{item.step}</span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ================= MODAL / LIGHTBOX ================= */}
      {dwProjCModal && (
        <div className="dw-projC-modal">
          <div
            className="dw-projC-modal-overlay"
            onClick={() => setDwProjCModal(null)}
          ></div>

          <motion.div
            className="dw-projC-modal-box-lightbox"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3 }}
          >
            {/* Close button */}
            <button
              className="dw-lightbox-close"
              onClick={() => setDwProjCModal(null)}
              aria-label="Close lightbox"
            >
              x
            </button>

            {/* Navigation Arrows */}
            {dwProjCModal.images && dwProjCModal.images.length > 1 && (
              <>
                <button
                  className="dw-lightbox-nav dw-lightbox-prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImgIndex((prev) =>
                      prev === 0 ? dwProjCModal.images.length - 1 : prev - 1
                    );
                  }}
                  aria-label="Previous image"
                >
                  <FaChevronLeft />
                </button>
                <button
                  className="dw-lightbox-nav dw-lightbox-next"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImgIndex((prev) =>
                      prev === dwProjCModal.images.length - 1 ? 0 : prev + 1
                    );
                  }}
                  aria-label="Next image"
                >
                  <FaChevronRight />
                </button>
              </>
            )}

            {/* Active Image */}
            <div className="dw-lightbox-image-wrapper">
              <img
                src={dwProjCModal.images[currentImgIndex]}
                alt={`${dwProjCModal.title} - view ${currentImgIndex + 1}`}
                className="dw-lightbox-image" 
              />
            </div>

            {/* Caption Badge */}
            <div className="dw-lightbox-caption">
              {dwProjCModal.title} | {dwProjCModal.location}
            </div>
          </motion.div>
        </div>
      )}

      {/* ================= CTA ================= */}
      <section className="dw-projC-cta">
        <motion.div
          className="dw-projC-cta-box"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>Ready to build your dream project?</h2>
          <p>
            Let's create premium architecture and construction projects with modern
            execution and luxury finishing.
          </p>
          <button
            className="dw-projC-btn"
            onClick={() => navigate("/estimate")}
          >
            Calculate My Cost
          </button>
        </motion.div>
      </section>

      <Footer 
        openContactModal={openContactModal}
        showCTA={showCTA} 
      />

    </div>
  );
}

